import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { PortfolioAssetClass } from "../types";
const Response = z.object({
    data: PortfolioAssetClass.array(),
});
export const portfolioAssetClassesURL = (portfolioPlanId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/investment/portfolio-plans/${portfolioPlanId}/asset-class`
    : `https://middleware.uat.farther.com/investment/portfolio-plans/${portfolioPlanId}/asset-class`;
export default async function getPortfolioAssetClasses(portfolioPlanId, config) {
    const { data } = await axios.get(portfolioAssetClassesURL(portfolioPlanId), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }),
            ...("clientId" in config && { Client: config.clientId }),
            Version: "20250313",
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[getPortfolioAssetClasses] Could not parse";
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getPortfolioAssetClasses.js.map